import { BookingReason } from './BookingReason'
import { BookingSlot } from './BookingSlot'
import { BookingSlotOption } from './BookingSlotOption'
import { Event } from './Event'

export class BookingSlotAvailability {
    constructor(
        public bookingSlot: BookingSlot,
        public options: BookingSlotOption[]
    ) { }

    isReservableWithConfiguration(
        partySize: number,
        reason: BookingReason | null,
        event: Event | null
    ): boolean {
        return this.options.some(option => {
            return option.isReservableWithConfiguration(partySize, reason, event)
        })
    }

    isReservableWithAnyReason(
        partySize: number,
        event: Event | null
    ): boolean {
        return this.options.some(option => {
            return option.isReservableWithAnyReason(partySize, event)
        })
    }

    reservableOptionWithConfiguration(
        partySize: number,
        reason: BookingReason | null,
        event: Event | null,
        dateTime: Date
    ): BookingSlotOption | null {
        if (this.bookingSlot.dateTime.getTime() !== dateTime.getTime()) {
            return null
        }
        return this.options.find(option => {
            return option.isReservableWithConfiguration(partySize, reason, event)
        }) ?? null
    }

    reservableOptionWithAnyReason(
        partySize: number,
        event: Event | null,
        dateTime: Date
    ): BookingSlotOption | null {
        if (this.bookingSlot.dateTime.getTime() !== dateTime.getTime()) {
            return null
        }
        return this.options.find(option => {
            return option.isReservableWithAnyReason(partySize, event)
        }) ?? null
    }

    isWaitlistOnlyWithConfiguration(
        partySize: number,
        reason: BookingReason | null,
        event: Event | null
    ): boolean {
        const hasNoReservable = !this.isReservableWithConfiguration(partySize, reason, event)
        const hasWaitlistable = this.options.some(option => {
            return option.isWaitlistOnlyWithConfiguration(partySize, reason, event)
        })
        return hasNoReservable && hasWaitlistable
    }
}

